import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgentNotificationSettingsDto } from '@workspace/data-types';

const MANDATE_LABELS: Record<string, string> = {
  exclusif: 'Mandat Exclusif',
  'co-exclusif': 'Co-exclusif',
  simple: 'Mandat Simple',
};

@Component({
  selector: 'etxe-agent-notifications-display',
  imports: [MatIconModule],
  templateUrl: './agent-notifications-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentNotificationsDisplayComponent {
  readonly settings = input<AgentNotificationSettingsDto | undefined>(undefined);

  readonly resolved = computed(() => {
    const s = this.settings();
    const mandateTypes = s?.mandateTypes?.length ? s.mandateTypes : ['exclusif', 'co-exclusif', 'simple'];
    const mandateLabels = mandateTypes.map((k) => MANDATE_LABELS[k] || k);

    let priceRangeText = 'Tous montants acceptés';
    if (s?.minPrice && s?.maxPrice) {
      priceRangeText = `${s.minPrice.toLocaleString('fr-FR')} € – ${s.maxPrice.toLocaleString('fr-FR')} €`;
    } else if (s?.minPrice) {
      priceRangeText = `Dès ${s.minPrice.toLocaleString('fr-FR')} €`;
    } else if (s?.maxPrice) {
      priceRangeText = `Jusqu'à ${s.maxPrice.toLocaleString('fr-FR')} €`;
    }

    return {
      emailAlertsEnabled: s?.emailAlertsEnabled ?? true,
      mandateLabels,
      priceRangeText,
      creditLowAlertEnabled: s?.creditLowAlertEnabled ?? true,
      creditThreshold: s?.creditThreshold ?? 2,
    };
  });
}
